import React, { useEffect, useState } from 'react'
import { AchivementWrapper } from './Styled'

import { useTranslation } from 'react-i18next'
import { Col, Container, Row } from 'react-bootstrap'
// import { Box, HeadingStyled, SpanStyled, TextStyled } from '../../Styled/Elements'
// import { FooterArrow } from '../../../ui/AllImages'
import { serviceMaintaneData } from '../../projectData/Data'
import { Box, HeadingStyled, MainHeading, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowBtn, ArrowBtnBrown, ArrowBtnWhite, Check } from '../../../ui/AllImages'
import { ContactButtonLink } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
const ServiceMaintane = () => {
    const { t } = useTranslation();
    const [activeItem, setActiveItem] = useState(null);

    
    /* useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 991) {
                setActiveItem(0); 
            } else {
                setActiveItem(null); 
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []); */
    useEffect(() => {
        // ✅ Check window size only once on load
        if (window.innerWidth >= 991) {
        setActiveItem(0); // first tab active only on desktop
        } else {
        setActiveItem(0); // none active on mobile
        }
    }, []); // no resize listener here!

    const toggleItem = (index) => {
        setActiveItem(activeItem === index ? 0 : index);
    };

    return (
        <AchivementWrapper className='common-space serviceArchiveSec'>
            <Container>
                <Row>
                    <Col md={12} className="servicesColMain">
                        <Row className=''>
                             <Col md={12}>
                                <Box className='servicesDescRow row'>
                                    <Col md={12} className='servicesDescRowInner' >
                                        <Row>
                                            <Col md={12} lg={6} className="servicesDescCol servicesDescCol1">
                                                
                                                    <MainHeading className='main-heading mb-1 servicesMH' color="var(--white)">
                                                        {t('AllToolsTitle')}
                                                    </MainHeading>
                                                    
                                                
                                                
                                            </Col>
                                            <Col md={12} className="servicesDescCol servicesDescCol2">
                                                
                                                    <SpanStyled className='d-flex mb-4 transformTxt' size="18px" color='var(--white)'>
                                                        {t('AllToolsDesc')}
                                                    </SpanStyled>
                                                    
                                                
                                                
                                            </Col>
                                        </Row>
                                    </Col>
                                    
                                </Box>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='item-container'>
                    <Col lg={3} md={12} className='item-container-left'>
                        {
                            serviceMaintaneData.map((list, index) => (
                                <Box>
                                    <Box key={index} className={`item-box ${activeItem === index ? 'active-item-box' : ''}`} onClick={() => toggleItem(index)}>
                                        <Box className='navTabIcon'>{list.icon}</Box>{t(list.heading)}
                                    </Box>
                                    {activeItem === index && (
                                        <Box className='service-solution-list mobile-view'>
                                            <Box className='service-img-container'>
                                                {i18n.language === "en" ? list.img : list.imgAr}
                                                    
                                                    
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            ))
                        }

                    </Col>
                    
                    <Col className='border-right desktop-view ssd-wrapper' lg={9} md={12}>
                        <Box className='service-solution-data-container' >
                            {serviceMaintaneData.map((list, index) => (
                                <Box key={index} className={`${activeItem === index ? '' : ''}`} >
                                    {activeItem === index && (
                                        <Box className='service-solution-list'>
                                            {/* <Box className='service-content-number'>{list.number2}</Box> */}
                                            
                                            <Box className='service-img-container'>
                                                {i18n.language === "en" ? list.img : list.imgAr}
                                                    
                                                    
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            ))}
                            
                        </Box>
                    </Col>
                    {/* {serviceMaintaneData.map((list, index) => {
                        return (
                            <>

                            </>
                        )
                    })} */}
                </Row>
            </Container>
        </AchivementWrapper >
    )
}

export default ServiceMaintane